import { useState } from 'react';
import Dashboard from './Dashboard';
import PropertiesManagement from './PropertiesManagement';
import UserManagement from './UserManagement';
import PasswordSettings from './PasswordSettings';
import SiteSettings from './SiteSettings';
import LeadsManagement from './LeadsManagement';

interface AdminLayoutProps {
  onLogout: () => void;
}

export default function AdminLayout({ onLogout }: AdminLayoutProps) {
  const [activeSection, setActiveSection] = useState('dashboard');

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: 'ri-dashboard-line' },
    { id: 'properties', label: 'Propiedades', icon: 'ri-building-line' },
    { id: 'leads', label: 'Gestión de Leads', icon: 'ri-customer-service-line' },
    { id: 'users', label: 'Usuarios', icon: 'ri-team-line' },
    { id: 'password', label: 'Seguridad', icon: 'ri-lock-password-line' },
    { id: 'settings', label: 'Configuración', icon: 'ri-settings-3-line' }
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return <Dashboard onSectionChange={setActiveSection} />;
      case 'properties':
        return <PropertiesManagement />;
      case 'leads':
        return <LeadsManagement />;
      case 'users':
        return <UserManagement />;
      case 'password':
        return <PasswordSettings />;
      case 'settings':
        return <SiteSettings />;
      default:
        return <Dashboard onSectionChange={setActiveSection} />;
    }
  };

  const handleGoHome = () => {
    window.REACT_APP_NAVIGATE('/');
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-4">
              <h1 className="text-2xl font-bold text-gray-900">Panel de Administración</h1>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm text-gray-600">Administrador</span>
              <button
                onClick={handleGoHome}
                className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap"
              >
                <i className="ri-logout-line mr-2"></i>
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="flex">
        {/* Sidebar */}
        <aside className="w-64 bg-white shadow-sm min-h-screen">
          <nav className="p-6">
            <ul className="space-y-2">
              {menuItems.map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => setActiveSection(item.id)}
                    className={`w-full flex items-center px-4 py-3 text-left rounded-lg transition-colors whitespace-nowrap ${
                      activeSection === item.id
                        ? 'bg-blue-100 text-blue-700 border-r-4 border-blue-700'
                        : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    <i className={`${item.icon} mr-3 text-lg`}></i>
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-6">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}
